module.exports = __webpack_public_path__ + "Olympos.f0205c026a0d0e57216a.ttf";


//////////////////
// WEBPACK FOOTER
// C:/WS/Fusion/FusionDashboard/resources/layout/fonts/Olympos.ttf
// module id = ../../../../../resources/layout/fonts/Olympos.ttf
// module chunks = styles